<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useId } from 'vue'

import { usePromptStore } from '@/stores'
import { onBeforeMount } from 'vue'
const emits = defineEmits(['cancelled', 'confirmed'])
const promptStore = usePromptStore()
const { message } = storeToRefs(promptStore)
//import { useUserPrompter } from '@/composables/User-prompter'
//import { onMounted } from 'vue';
//const { message, closePrompt, promptUser } = useUserPrompter();
//import type { PrompterMessage } from '@/stores/prompt-store';

const props = defineProps<{
  name : String
}>()

const uuid = useId();

//onMounted(()=>{
//  promptUser(props.msg);
//})



function close(){
  console.log(props.name + " prompt.vue close()... uuid = " + uuid);
  emits('cancelled');
  promptStore.close();
  //closePrompt();
}
//watch alert and change visibility of myModal?
</script>

<template>
  <!--div v-if="alert" class="container">-->

  <!-- The Modal -->
  <div v-if="message" id="myPromptModal" class="modal">
    <!-- Modal content -->
    <div class="modal-content">
      <!--span class="close">&times;</span>-->
      <div class="modal-header">
        <slot name="modal-header">
          <p>{{ message.header }}</p>
          <button @click="close()" class="btn btn-link close">&times;</button>
        </slot>
        <!--button @click="alertStore.clear()" class="btn btn-link close">&times;</button>-->
      </div>
      <div class="modal-body">
        <slot name="modal-body">
          <p>{{ message.body }}</p>
          <!--p>{{ alert.message }}</p>-->
        </slot>
      </div>
      <div class="modal-footer">
        <slot name="modal-footer">
          <!--button @click="promptStore.close()" class="btn btn-link">Cancel</button-->
          <button @click="close" class="btn btn-link">Cancel</button>
          <button @click="emits('confirmed')" class="btn btn-link">Confirm</button>

          <!--<button type="button">OK</button>
                    <button type="button">Cancel</button>-->
        </slot>
      </div>
    </div>
  </div>
  <!--
        <div class="m-3">
            <div class="alert alert-dismissable" :class="alert.type">
                <button @click="alertStore.clear()" class="btn btn-link close">&times;</button>
                {{ alert.message }}
            </div>
        </div>
    -->

  <!-- Trigger/Open The Modal -->
  <!--button id="myBtn">Open Modal</button-->
</template>


<style lang="css" scoped>
/* The Modal (background) */
.modal {
  display: block;
  /*display: block;*/
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 1001;
  /* Sit on top */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
}

/* Modal Content/Box */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  /* 15% from the top and centered */
  padding: 0;
  /*padding-bottom: 4rem;*/
  border: 1px solid black;
  border-radius: 0.375rem;
  width: 20%;
  box-shadow: inset;
  /* Could be more or less, depending on screen size */
  box-shadow:
    0 4px 8px 0 rgba(0, 0, 0, 0.2),
    0 6px 20px 0 rgba(0, 0, 0, 0.19);
  animation-name: animatetop;
  animation-duration: 0.4s;
}

/* The Close Button */
.close {
  color: white;
  float: right;
  font-size: 2rem;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.modal-header {
  background-color: var(--blue);
  color: white;
  /*height: 2rem;*/
  font-size: 1rem;
  padding: 0rem 0.25rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.modal-body {
  padding: 0.25rem 0.25rem;
  font-size: 1rem;
}

.modal-footer {
  padding: 0.5rem 1rem;
  display: flex;
  flex-direction: row-reverse;
  align-items: start;
  justify-content: end;
  gap: 1rem;
}

/* Add Animation */
@keyframes animatetop {
  from {
    top: -300px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
</style>
